export default __webpack_public_path__ + "static/media/agld.a620187b.webp";